import type { StatePack } from './types'

/**
 * Arizona state pack, the demo target Ken's pitch leads with.
 * Arizona ranks #4 per-capita for fraud losses and has one of the most
 * skewed elder-fraud profiles in the country (60+ = ~22% of population
 * but 54.5% of fraud losses per IC3 2025).
 */
export const az: StatePack = {
  slug: 'az',
  name: 'Arizona',
  topScams: [
    {
      id: 'investment-fraud',
      name: 'Investment',
      blurb:
        'Crypto investment scams ("pig butchering") drove the largest share of Arizona losses. Most start with a stranger texting a "wrong number," then move the target onto a fake trading app.',
      lossUsd: 296_000_000,
    },
    {
      id: 'tech-support',
      name: 'Tech Support',
      blurb:
        'Fake Microsoft, Apple, and bank "fraud department" calls remain a top loss category for older Arizonans. Often paired with remote-access tools.',
      lossUsd: 88_000_000,
    },
    {
      id: 'business-email-compromise',
      name: 'Business Email',
      blurb:
        'Scammers impersonate executives, contractors, and title companies to redirect wire transfers, particularly in real-estate closings.',
      lossUsd: 71_000_000,
    },
    {
      id: 'romance-scams',
      name: 'Romance',
      blurb:
        'Months-long online relationships that end in an urgent ask for money. Often a feeder for crypto investment fraud.',
      lossUsd: 33_000_000,
    },
    {
      id: 'government-impersonation',
      name: 'Govt Impersonation',
      blurb:
        'Fake IRS, Social Security, and ICE agents demanding payment via gift cards or wire transfer. High losses among Spanish-speaking communities.',
      lossUsd: 21_000_000,
    },
  ],
  agencies: [
    {
      name: 'Arizona Attorney General, Consumer Information & Complaints',
      description: 'File a complaint or get help with a scam targeting Arizona residents.',
      url: 'https://www.azag.gov/consumer',
      phone: '1-602-542-5763',
    },
    {
      name: 'Arizona AG, Elder Fraud Unit',
      description: 'Specialized help for fraud targeting Arizonans aged 60+.',
      url: 'https://www.azag.gov/seniors',
      phone: '1-602-542-2124',
    },
    {
      name: 'IC3 (FBI Internet Crime Complaint Center)',
      description: 'Report internet-enabled crime and fraud.',
      url: 'https://www.ic3.gov',
    },
    {
      name: 'AARP Arizona Fraud Watch Helpline',
      description: 'Talk to a trained fraud specialist.',
      phone: '1-877-908-3360',
    },
  ],
  exampleOverrides: {
    'pv-call-bank': {
      bankName: 'Wells Fargo',
      bankPhone: '1-800-869-3557',
    },
    'ws-pig-butchering': {
      cityName: 'Phoenix',
      platformName: 'a popular dating app',
    },
  },
}
